import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, CircularProgress, FormControlLabel } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import useProvidersIM from 'hooks/useProvidersIM';
import Checkbox from '@material-ui/core/Checkbox';
import { iProviders } from 'interfaces/imProviders.interface';

interface Props {
  handleCloseModal(): void;
  handleOnSubmit(data: iProviders): Promise<boolean>;
  getAllProviders(): void;
  providerId: string;
}

export default function IMProviderForm({ handleCloseModal, handleOnSubmit, providerId, getAllProviders }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotistack } = useCustomSnackbar();
  const { handleSubmit, register, errors, reset, control } = useForm<iProviders>();
  const { getProviderById } = useProvidersIM();

  const onSubmit = (data: iProviders) => {
    setIsLoading(true);

    if (providerId) {
      data.id = providerId;
    }
    handleOnSubmit(data)
      .then((response: boolean) => {
        if (response === true) {
          showNotistack({ message: 'El proveedor se guardó correctamente' });
          getAllProviders();
          handleCloseModal();
        } else {
          showNotistack({ message: 'Ocurrió un error' });
        }
      })
      .catch((err: any) => {
        console.log(err.reponse?.data);
        showNotistack({ message: 'Ocurrió un error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (providerId) {
      setIsLoading(true);
      getProviderById(providerId)
        .then((resultCategory: iProviders) => {
          reset(resultCategory);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [providerId]);

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <Grid container direction="row" spacing={2} justify="center">
        <Grid item xs={12} sm={12} md={12}>
          <Grid container direction="row" spacing={2} justify="center">
            <Grid item xs={6}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="name"
                label="Nombre"
                autoComplete="name"
                autoFocus
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido'
                })}
                error={errors.name ? true : false}
                helperText={errors.name && errors.name.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="nit"
                label="NIT"
                autoComplete="nit"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido'
                })}
                error={errors.nit ? true : false}
                helperText={errors.nit && errors.nit.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid container direction="row" spacing={2} justify="center">
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email de contacto"
                name="email"
                autoComplete="email"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Email invalido'
                  }
                })}
                error={errors.email ? true : false}
                helperText={errors.email && errors.email.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="phone"
                label="Teléfono"
                autoComplete="phone"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido',
                  pattern: {
                    value: /^[0-9\b]+$/,
                    message: 'Teléfono invalido'
                  }
                })}
                error={errors.phone ? true : false}
                helperText={errors.phone && errors.phone.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid container direction="row" justify="flex-start">
            <FormControlLabel
              control={
                <Controller
                  name="status"
                  control={control}
                  defaultValue={true}
                  render={(props) => (
                    <Checkbox
                      color="primary"
                      onChange={(e) => props.onChange(e.target.checked)}
                      checked={props.value ? props.value : false}
                    />
                  )}
                />
              }
              label="Estado"
            />
          </Grid>
        </Grid>

        <Button type="submit" variant="contained" color="primary" disabled={isLoading} style={{ marginTop: 20 }}>
          {isLoading ? <CircularProgress size={24} /> : ''} Guardar
        </Button>
        <Button
          variant="contained"
          color="default"
          disabled={isLoading}
          style={{ marginTop: 20, marginLeft: 20 }}
          onClick={handleCloseModal}
        >
          {isLoading ? <CircularProgress size={24} /> : ''} Cancelar
        </Button>
      </Grid>
    </form>
  );
}
